import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../../../app.component';
import { NotifierService } from 'angular-notifier';
import { PendenciaTipo } from 'src/app/shared/models/pendencia-tipo';
import { PendenciaTipoService } from 'src/app/core/services/pendencia-tipo.service';

@Component({
    selector: 'app-pendencia-tipo-listar',
    templateUrl: './pendencia-tipo-listar.component.html',
    styleUrls: ['./pendencia-tipo-listar.component.css'],
})
export class PendenciaTipoListarComponent implements OnInit {
    pendencias_tipo: PendenciaTipo;
    codigo_pendencia_tipo;
    breadCrumb;
    pendencias_tipo_inativos: PendenciaTipo;
    carregando;

    constructor(
        private appComponent: AppComponent,
        private pendenciaTipoService: PendenciaTipoService,
        private notifierService: NotifierService,
    ) {}

    ngOnInit() {
        this.breadCrumb = [
            { nome: 'Configuração', caminho: 'configuracao' },
            { nome: 'pendencias_tipo', caminho: '/pendencia-tipo-listar' },
        ];
        this.appComponent.setTitulo('Pendencias Tipo Cadastradas');
        this.appComponent.setBreadcrumb(this.breadCrumb);

        this.listar();
    }

    definirCodigo(codigo_pendencia_tipo) {
        this.codigo_pendencia_tipo = codigo_pendencia_tipo;
    }

    listar(): void {
        this.pendenciaTipoService.list(false).subscribe(
            (data: PendenciaTipo) => {
                this.pendencias_tipo = data;
            },
            (error) => console.log(error),
        );

        this.pendenciaTipoService.list(true).subscribe(
            (data_inativo: PendenciaTipo) => {
                this.pendencias_tipo_inativos = data_inativo;
            },
            (error) => console.log(error),
        );
    }

    apagar(codigo_pendencia_tipo): void {
        this.carregando = true;
        this.pendenciaTipoService.delete(codigo_pendencia_tipo).subscribe(
            (data) => {
                this.listar();
                this.carregando = false;
                this.notifierService.notify(
                    'success',
                    'Registro DELETADO com sucesso.',
                );
            },
            (error) => {
                this.notifierService.notify('error', error);
                this.carregando = false;
            },
        );
    }

    restaurar(codigo_pendencia_tipo) {
        this.pendenciaTipoService.restore(codigo_pendencia_tipo).subscribe(
            (data) => {
                this.listar();
                this.notifierService.notify(
                    'success',
                    'Registro RESTAURADO com sucesso.',
                );
            },
            (error) => {
                this.notifierService.notify(
                    'error',
                    'Não foi possível REATIVAR o registro. ' + error,
                );
            },
        );
    }
}
